import { includes, map, isNil, hasIn } from 'lodash';

import * as layerOps from '../api/Layers/layer-operations';
import { LAYER_SUBTYPES } from '../api/Layers/Layers';
import * as styleOps from '../api/Styles/style-operations';
import { getStyleType, STYLE_TYPES, SYMBOLOGY_TYPES } from '../api/Styles/Styles';

/**
 * Loads and style stored on an external url.
 *
 * @async
 * @param {object} arg - The object argument.
 * @param {string} arg.url - The url of the style to load.
 * @param {object} arg.layer - The layer object.
 * @returns {object} The loaded style.
 * @throws {Error} If something goes wrong.
 */

const loadStyleFromURL = async ({ url, layer }) => {
  const style = {
    name: layerOps.getName(layer),
    styleType: layerOps.isJoin(layer)
      ? getStyleType(LAYER_SUBTYPES.GEOJSON)
      : getStyleType(layerOps.getSubType(layer))
  };

  try {
    const response = await fetch(url);
    if (response.ok) {
      const json = await response.json();

      if (isNil(json)) throw new Error('Empty Response');

      if (hasIn(json, 'default') && hasIn(json, 'styles')) return json;

      if (styleOps.getType(style) === STYLE_TYPES.RASTER) {
        if (hasIn(json, 'styleData')) throw new Error('Wrong Style Type');
        style.rasterStyle = json;
        return style;
      }

      if (
        json.type === SYMBOLOGY_TYPES.SINGLE ||
        includes(map(layerOps.getGeoJSONProps(layer), 'name'), json.propName)
      ) {
        if (hasIn(json, 'opacity')) throw new Error('Wrong Style Type');
        style.geojsonStyle = json;
        return style;
      }

      throw new Error('This style do not match de layer');
    }
    throw new Error('Network response was not ok. Server Error');
  } catch (err) {
    throw new Error(err.message);
  }
};

export default loadStyleFromURL;
